var now = +new Date();
var index = 0;

export default function uid() {
  return "vc-upload-" + now + "-" + ++index;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-upload/src/uid.js
// module id = null
// module chunks = 